import { Component, OnInit , OnDestroy} from '@angular/core';
import { DoctorService } from '../services/doctor.service';
import { CommonService } from '../services/common.service';
import * as moment from 'moment';
@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.css']
})
export class DoctorComponent implements OnInit, OnDestroy {
  totalchat: any;
  totalleavecount: any;
  leave: any;
  userid: any;
  public loading = false;
  sprovider: any;
  today: any;
  appointment = [];
  month: any;
  year: any;
  date = moment();
  chat: any;
  upcommingchat = 0;
  timer: any;
  constructor(private doctorservice:  DoctorService, private commonService: CommonService) {
    this.totalleavecount = 0;
    this.totalchat = 0;
    this.timer = setInterval(() => this.timedelay(), 1000);
  }

ngOnInit() {
    this.loading = true;
     }
     timedelay() {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      if (this.userid != undefined) {
        clearInterval(this.timer);
        this.commonService.loginsuccess.next(1);
        this.doctorservice.getServiceproviderownId(this.userid)
        .subscribe(
          (x) => {
           this.sprovider = x;
           this.getTime();
        });
      }
     }
  getTime() {
    this.doctorservice.getTime()
    .subscribe(
      (d) => {
        const ctime = d.date;
        const css = moment(ctime.date).format('YYYY-MM-DD');
        this.today = css;
        const str = css.toString()
        this.month = str.substr(5, 2);
        this.year = str.substr(0, 4)
        this.getApppointmentWithMe(this.sprovider[0].id);
        this.getThisMonthleave(this.sprovider[0].id);
        this.getMyChat();
        this.loading = false;
      });
  }
  getApppointmentWithMe(spid) {
    this.doctorservice.getAppointmentWithMe(spid)
    .subscribe(
      (b) => {
        this.appointment = b;
        let i = this.appointment.length;
        while (i--) {
          if (this.appointment[i].date !== this.today) {
          this.appointment.splice(i , 1);
          }
        }
      });
    }
    getThisMonthleave(id) {
      this.doctorservice.getMyLeaves(id)
      .subscribe(
        (x) => {
          this.leave = x;
          for ( let i = 0; i < this.leave.length ; i ++) {
            const str = this.leave[i].date.toString()
            const mn = str.substr(5, 2);
            const  yr = str.substr(0, 4);
            if (mn === this.month && yr === this.year) {
              this.totalleavecount = this.totalleavecount + 1;
            }
          }
        }
      );
    }
    getMyChat() {
      this.doctorservice.getMyChat(this.userid)
      .subscribe(
        (x) => {
          this.chat = x;
          for (let i = 0 ; i < this.chat.length ; i++) {
            const css = moment(this.chat[i].startTimeMs).format('YYYY-MM-DD');
            if (css === this.today) {
              this.totalchat = this.totalchat + 1;
            }else if (css > this.today) {
              this.upcommingchat = this.upcommingchat + 1;
            }
          }
        });
    }

    ngOnDestroy() {
      this.leave = [];
      this.appointment = [];
      delete this.leave;
      delete this.appointment;
      delete this.totalleavecount;
      delete this.chat;
    }
}
